import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { ClusterFormComp, ClusterListComp } from 'pages/complementar/cluster/components';

export function ClusterList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_CLUSTER_LOJA_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <ClusterListComp />
        </ListagemProvider>
    );
}

export function ClusterForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_CLUSTER_LOJA_GERENCIAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <ClusterFormComp />
        </FormProvider>
    );
}
